<template>
  <div id="user-settings" class="font-h3">
    <div class="settings-item">
      <span class="settings-item-name">编号</span>
      <span>{{ userInfo.userNumber }}</span>
    </div>
    <div class="settings-item">
      <span class="settings-item-name">昵称</span>
      <el-input
        v-model="userInfo.nickName"
        class="settings-item-input"
        @change="handleChangeNickName"
      ></el-input>
    </div>
    <div class="show-tip" v-if="nickNameTip">
      <span>已存在该昵称</span>
    </div>
    <div class="settings-item">
      <span class="settings-item-name">密码</span>
      <span>******</span>
      <span class="settings-item-change" @click="handleChangePassword(true)"
        >修改</span
      >
    </div>
    <div class="settings-item">
      <span class="settings-item-name">角色</span>
      <span>{{ roleNames }}</span>
    </div>
    <user-popup-vue v-model="showPopup" />
  </div>
</template>

<script>
import userPopupVue from '../../components/user/user-popup.vue';
import { mapMutations, mapGetters } from 'vuex';
import { modifyNickName } from '../../api/index';
import { regEpxDeleteSpace } from '../../config/regEpx.js';
export default {
  name: 'User',
  components: {
    userPopupVue
  },
  computed: {
    ...mapGetters('login', ['authToken', 'userInfo']),
    roleNames() {
      let roleName = '';
      this.userInfo.userUserRoleList.forEach(e => {
        roleName = roleName + ' ' + e.roleName;
      });
      return roleName;
    }
  },
  data() {
    return {
      showPopup: false,
      nickNameTip: false
    };
  },
  methods: {
    ...mapMutations('login', ['setUserInfo']),
    handleChangePassword(flag) {
      this.showPopup = flag;
    },
    /**
     * 修改昵称回调
     */
    handleChangeNickName(nickName, userUid) {
      this.userInfo.nickName = regEpxDeleteSpace(this.userInfo.nickName);
      if (this.userInfo.nickName) {
        modifyNickName({
          nickName: this.userInfo.nickName,
          userUid: this.userInfo.uid
        }).then(res => {
          if (res.data.code == 200) {
            this.setUserInfo(res.data.data);
            this.nickNameTip = false;
            this.$prompt('修改成功');
          } else if (res.data.code == 500) {
            this.nickNameTip = true;
          }
        });
      } else {
        this.$prompt('昵称不能为空');
      }
    }
  }
};
</script>

<style lang="scss">
#user-settings {
  margin-top: 132px !important;
  .settings-item {
    height: 16px;
    padding: 16px 0;
    line-height: 16px;
    box-sizing: content-box;
    &-name {
      margin-right: 60px;
      color: #7f7f7f;
    }
    &-input {
      width: 150px;
      height: 25px !important;
      .el-input__inner {
        height: 25px;
        padding-left: 2px;
        border-radius: 0;
      }
    }
    &-change {
      margin-left: 310px;
      color: $color-primary;
      cursor: pointer;
    }
  }
  .show-tip {
    margin-left: 88px;
    color: red;
    font-size: 11px;
  }
}
</style>
